import React, { Component } from "react";
import { Link } from "react-router-dom";
import { 
  TextField, 
  Button, 
  Typography 
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Alert } from "@material-ui/lab";
import SendIcon from "@material-ui/icons/Send";

import { withFirebase } from "../Firebase";
import * as ROUTES from "../../constants/routes";

const styles = (theme) => ({
  form: {
    width: '100%',
  },
  textField: {
    marginBottom: theme.spacing(2),
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      '&:hover fieldset': {
        borderColor: '#667eea',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#667eea',
      },
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: '#667eea',
    },
  },
  button: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: '#ffffff',
    padding: theme.spacing(1.5),
    borderRadius: '8px',
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
    '&:hover': {
      background: 'linear-gradient(135deg, #5568d3 0%, #6b3f91 100%)',
      boxShadow: '0 6px 20px rgba(102, 126, 234, 0.6)',
    },
    '&:disabled': {
      background: '#e0e0e0',
      color: '#9e9e9e',
    },
  },
  successAlert: {
    marginTop: theme.spacing(2),
    borderRadius: '8px',
  },
  errorAlert: {
    marginTop: theme.spacing(2),
    borderRadius: '8px',
  },
  helperText: {
    color: '#92929f',
    fontSize: '0.875rem',
    marginBottom: theme.spacing(2),
  },
});

const PasswordForgetPage = () => (
  <div>
    <h1>PasswordForget</h1>
    <PasswordForgetForm />
  </div>
);

const INITIAL_STATE = {
  email: "",
  error: null,
  success: false,
};

class PasswordForgetFormBase extends Component {
  constructor(props) {
    super(props);

    this.state = { 
      ...INITIAL_STATE,
      email: props.userEmail || ""
    };
  }

  onSubmit = (event) => {
    const { email } = this.state;

    this.props.firebase
      .doPasswordReset(email)
      .then(() => {
        this.setState({ ...INITIAL_STATE, success: true });
        setTimeout(() => {
          this.setState({ success: false });
        }, 5000);
      })
      .catch((error) => {
        this.setState({ error, success: false });
      });

    event.preventDefault();
  };

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { email, error, success } = this.state;
    const { classes } = this.props;

    const isInvalid = email === "";

    return (
      <form onSubmit={this.onSubmit} className={classes.form}>
        <Typography variant="body2" className={classes.helperText}>
          Digite seu email para receber um link de recuperação de senha
        </Typography>
        
        <TextField
          name="email"
          value={email}
          onChange={this.onChange}
          type="email"
          label="Email"
          placeholder="seuemail@exemplo.com"
          fullWidth
          variant="outlined"
          className={classes.textField}
          InputProps={{
            readOnly: !!this.props.userEmail,
          }}
          disabled={!!this.props.userEmail}
        />
        
        <Button 
          disabled={isInvalid} 
          type="submit"
          fullWidth
          className={classes.button}
          startIcon={<SendIcon />}
        >
          Enviar Link de Recuperação
        </Button>

        {success && (
          <Alert severity="success" className={classes.successAlert}>
            Email de recuperação enviado! Verifique sua caixa de entrada.
          </Alert>
        )}

        {error && (
          <Alert severity="error" className={classes.errorAlert}>
            {error.message}
          </Alert>
        )}
      </form>
    );
  }
}

const PasswordForgetLink = () => (
  <p>
    <Link to={ROUTES.PASSWORD_FORGET}>Esqueceu sua senha?</Link>
  </p>
);

export default PasswordForgetPage;

const PasswordForgetForm = withFirebase(withStyles(styles)(PasswordForgetFormBase));

export { PasswordForgetForm, PasswordForgetLink };
